import { useAnalytics } from '@medely/ui-kit';
import { useOTAMetadata } from '../useOTAMetadata';
import { useImpersonating } from '../useImpersonating';

export type TrackRecommendedListItemClickPayload = {
  qualification_id?: number;
};

export type TrackUploadModalViewPayload = {
  qualification_id?: number;
};

export type TrackUploadModalNextClickPayload = {
  qualification_id?: number;
};

export function useUploadCredentialEvent() {
  const analytics = useAnalytics();
  const otaMetadata = useOTAMetadata();
  const isImpersonating = useImpersonating();

  const trackRecommendedListItemClicked = (payload: TrackRecommendedListItemClickPayload) => {
    analytics.track({
      context: 'Upload Credential',
      subcontext: 'Recommended List Item',
      action: 'Clicked',
      ...payload,
      impersonating: isImpersonating,
      ...otaMetadata,
    });
  };

  const trackUploadModalViewed = (payload: TrackUploadModalViewPayload) => {
    analytics.track({
      context: 'Upload Credential',
      subcontext: 'Upload Modal',
      action: 'Viewed',
      ...payload,
      impersonating: isImpersonating,
      ...otaMetadata,
    });
  };

  const trackUploadModalNextClicked = (payload: TrackUploadModalNextClickPayload) => {
    analytics.track({
      context: 'Upload Credential',
      subcontext: 'Upload Modal Next Button',
      action: 'Clicked',
      ...payload,
      impersonating: isImpersonating,
      ...otaMetadata,
    });
  };

  return {
    trackRecommendedListItemClicked,
    trackUploadModalViewed,
    trackUploadModalNextClicked,
  };
}
